import { AvaliacaoDesenvolvimentoInput, PrenatalPartoNascimentoInput, PuericulturaInput } from 'graphql/types.generated'
import { parseNumber } from 'util/number'

import { AlteracoesFenotipicasModel } from './alteracao-fenotipica/AlteracaoFenotipicaView'
import { FatoresRiscoModel } from './fatores-risco/FatoresRiscoView'
import { PrenatalPartoNascimentoModel } from './prenatal-parto-nascimento/PrenatalPartoNascimento'
import { PuericulturaModel } from './PuericulturaView'

export const convertPuericulturaToInput = (values: PuericulturaModel): PuericulturaInput => ({
  prenatalPartoNascimento: values.prenatal && convertPrenatalPartoNascimento(values.prenatal),
  tipoAleitamento: values.prenatal?.tipoAleitamento, // TODO - foundation rever na historia de prenatalPartoNascimento
  fatoresRisco: values.fatoresRisco && convertFatoresRisco(values.fatoresRisco),
  alteracoesFenotipicas: values.alteracoesFenotipicas && convertAlteracoesFenotipicas(values.alteracoesFenotipicas),
})

const convertPrenatalPartoNascimento = (values: PrenatalPartoNascimentoModel): PrenatalPartoNascimentoInput => ({
  tipoParto: values.tipoParto?.value,
  tipoGravidez: values.tipoGravidez?.value,
  apgarPrimeiroMinuto: values.apgarUm,
  apgarQuintoMinuto: values.apgarCinco,
  apgarDecimoMinuto: values.apgarDez,
  altura: parseNumber(values.comprimento),
  peso: parseNumber(values.peso),
  perimetroCefalico: parseNumber(values.perimetroCefalico),
  idadeGestacionalEmDias: values.idadeGestacional?.dias,
  idadeGestacionalEmSemanas: values.idadeGestacional?.semanas,
})

const convertFatoresRisco = (values: FatoresRiscoModel): AvaliacaoDesenvolvimentoInput[] =>
  values.fatoresRisco.map((it) => ({
    id: it.id,
    status: it.statusButton,
  }))

const convertAlteracoesFenotipicas = (values: AlteracoesFenotipicasModel): AvaliacaoDesenvolvimentoInput[] =>
  values.alteracoesFenotipicas.map((it) => ({
    id: it.id,
    status: it.statusButton,
  }))
